/* eslint-disable no-unused-vars */

// Pubsub
import { gptPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { i18n } from "@i18n";
import { wdConfigData } from "@/service/wd_app_config.js";

const Office = window.Office;
// const PowerPoint = window.PowerPoint;

export async function insertImageByCompletionUrl(completionImageUrl, options) {
  const PowerPoint = window.PowerPoint;
      try {  
        await PowerPoint.run(async (context) => {  
            // const imageUrl = "https://example.com/image.jpg"; // 替换为你的图片URL  
              
            // 下载图片为base64编码  
            const response = await fetch(completionImageUrl);  
            const blob = await response.blob();  
            const reader = new FileReader();  
            reader.readAsDataURL(blob);  
            reader.onloadend = async () => {  
                const base64data = reader.result.split(",")[1]; // 获取base64数据部分  

                // 注意要去掉base64的前缀
                // let index = base64data.indexOf("base64,");
                // let imageBase64 = base64data.substring(index + 7);
                Office.context.document.setSelectedDataAsync(
                  base64data,
                  options,
                  function (asyncResult) {
                    if (asyncResult.status === Office.AsyncResultStatus.Failed) {
                      reject(console.error(asyncResult.error.message));
                    } else {
                      resolve("Success");
                    }
                  }
                );
                // // 插入图片到当前幻灯片  
                // let selectedSlides = context.presentation.getSelectedSlides();
                // selectedSlides.load("items");
                // await context.sync();
                // let selectedSlide = selectedSlides.items[0];
                // // 获取当前幻灯片的信息
                // selectedSlide.load("shapes");
                // await context.sync();
                // selectedSlide.shapes.addImage(base64data);  
                // context.sync();  
            };  
        });  
    } catch (error) {  
        console.error(error);  
    }  
    // await new Promise((resolve, reject) => {
    //   let imageUrl = completionImageUrl;
    //   var img = new Image();
    //   img.src = imageUrl;
    //   img.crossOrigin = "Anonymous";
    //   img.onload = async () => {
    //     resolve(img);
    //   };
    // }).then((img) => {
    //   new Promise((resolve, reject) => {
    //     let dataURL = "";
    //     var canvas = document.createElement("canvas"),
    //       width = img.width,
    //       height = img.height;
    //     canvas.width = width;
    //     canvas.height = height;
    //     canvas.getContext("2d").drawImage(img, 0, 0, width, height);
    //     dataURL = canvas.toDataURL("image/jpeg");
    //     resolve(dataURL);
    //   }).then((base64Data) => {
    //     new Promise((resolve, reject) => {
    //       // 注意要去掉base64的前缀
    //       let index = base64Data.indexOf("base64,");
    //       let imageBase64 = base64Data.substring(index + 7);
    //       Office.context.document.setSelectedDataAsync(
    //         imageBase64,
    //         options,
    //         function (asyncResult) {
    //           if (asyncResult.status === Office.AsyncResultStatus.Failed) {
    //             reject(console.error(asyncResult.error.message));
    //           } else {
    //             resolve("Success");
    //           }
    //         }
    //       );
    //     });
    //   });
    // });
  }